import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_get_reasoncodes_by_lookupcode_parentId_parentEntityIdService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { parentId: number, parentEntity: string, lookupcode: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.parentId)) {
      missingRequiredInParams.push('\'parentId\'');
    }
    if (isNil(inParams.parentEntity)) {
      missingRequiredInParams.push('\'parentEntity\'');
    }
    if (isNil(inParams.lookupcode)) {
      missingRequiredInParams.push('\'lookupcode\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_get_reasoncodes_by_lookupcode_parentId_parentEntityId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { parentId: number, parentEntity: string, lookupcode: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.parentId)) {
      missingRequiredInParams.push('\'parentId\'');
    }
    if (isNil(inParams.parentEntity)) {
      missingRequiredInParams.push('\'parentEntity\'');
    }
    if (isNil(inParams.lookupcode)) {
      missingRequiredInParams.push('\'lookupcode\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_get_reasoncodes_by_lookupcode_parentId_parentEntityId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { parentId: number, parentEntity: string, lookupcode: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.parentId)) {
      missingRequiredInParams.push('\'parentId\'');
    }
    if (isNil(inParams.parentEntity)) {
      missingRequiredInParams.push('\'parentEntity\'');
    }
    if (isNil(inParams.lookupcode)) {
      missingRequiredInParams.push('\'lookupcode\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_get_reasoncodes_by_lookupcode_parentId_parentEntityId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
